import { SlotAvailability } from '@wix/ambassador-availability-calendar/types';
import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { NavigateToNextPage } from '../navigateToNextPage/navigateToNextPage';
import {
  isSlotLocked,
  isSlotWithOpenWaitingList,
} from '../../../../utilsDeprecated/slotAvailability/slotAvailability';

export type OnSlotSelected = (selectedSlotsIds: number[]) => void;

export function createOnSlotSelectedAction(
  actionFactoryParams: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>,
  navigateToNextPage: NavigateToNextPage,
): OnSlotSelected {
  return async (selectedSlotsIds) => {
    const { getControllerState } = actionFactoryParams;
    const [state, setState] = getControllerState();
    const { availableSlots } = state;

    const selectedSlotId = selectedSlotsIds[0];
    const selectedSlot: SlotAvailability =
      availableSlots!.availabilityEntries![selectedSlotId];

    const isWaitingListFlow =
      isSlotWithOpenWaitingList(selectedSlot) || isSlotLocked(selectedSlot);

    setState(
      {
        selectableSlotsAtSelectedTime: [selectedSlot],
        selectedTime: selectedSlot.slot!.startDate,
      },
      { immediate: true },
    );

    await navigateToNextPage({
      selectedSlots: [selectedSlot],
      isWaitingListFlow,
    });
  };
}
